import React from 'react';
import { Link } from 'react-router-dom';

const Keywords: React.FC<{ keywords: any[] }> = ({ keywords }) => {
  return (
    <div className="side-sections pt-5">
      <h3>熱門關鍵字</h3>
      <div className="article-tags">
        {keywords.map((keyword: any) => (
          <Link key={keyword.id} to={`/blog/filter#${keyword.Hashtags}`} className="btn">#{keyword.Hashtags}</Link>
        ))}
      </div>
    </div>
  );
};

export default Keywords;